import styled from 'styled-components';

import { getPurpurSpacing } from '@telialt/common-theme/src/purpurSelectors';

export const ListSuggestionsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${getPurpurSpacing('200')};
`;
